// https://github.com/react-ga/react-ga/issues/122#issuecomment-353101102

import * as React from "react";
import { Route, RouteComponentProps } from "react-router-dom";

import { page } from "../../analytics";

class Analytics extends React.Component<RouteComponentProps<any>> {
  public componentDidMount() {
    this.sendPageChange(
      this.props.location.pathname,
      this.props.location.search
    );
  }

  public componentDidUpdate(prevProps: RouteComponentProps<any>) {
    if (
      this.props.location.pathname !== prevProps.location.pathname ||
      this.props.location.search !== prevProps.location.search
    ) {
      this.sendPageChange(
        this.props.location.pathname,
        this.props.location.search
      );
    }
  }

  public sendPageChange(pathname: string, search: string = "") {
    const path = pathname + search;
    page(path);
  }

  public render() {
    return null;
  }
}

const AnalyticsTracker = () => {
  return <Route component={Analytics} />;
};

export default AnalyticsTracker;



// WEBPACK FOOTER //
// ./src/components/AnalyticsTracker/AnalyticsTracker.tsx